
<script>
import localforage from 'localforage'
import { mapActions, mapGetters } from 'vuex'
export default {
  mounted () {
    $('.dropdown-button').dropdown({
      inDuration: 300,
      outDuration: 225,
      constrainWidth: false,
      hover: true,
      gutter: 0,
      belowOrigin: false,
      alignment: 'right',
      stopPropagation: false
    })

    $('#toggle-sidebar').sideNav()
    $('#sidebar .item-sidebar').click(function () {
      if (!$(this).hasClass('active')) {
        $('#sidebar .item-sidebar').removeClass('active')
        $(this).addClass('active')
        $('#sidebar .collapsible-body').slideUp()
        $('.rotatearrow').html('keyboard_arrow_down')
        $('.collapsible-body', this).slideDown()
        $('.rotatearrow', this).html('keyboard_arrow_right')
      }
    })

    $('#sidebar .item-unico').click(function () {
      $('#sidebar .item-sidebar').removeClass('active')
      $(this).addClass('active')
      $('#sidebar .collapsible-body').slideUp()
      $('.collapsible-body ul li').removeClass('active')
      $('.rotatearrow').html('keyboard_arrow_down')
    })

    $('.collapsible-body ul li').click(function () {
      $('.collapsible-body ul li').removeClass('active')
      $(this).addClass('active')
    })

    $('#sidebar .to').click(function () {
      $('#sidebar .item-unico').removeClass('active')
      $('#toggle-sidebar').sideNav('hide')
    })
  },
  computed: {
    ...mapGetters(['nome', 'sobrenome', 'email', 'imagem', 'permissoes']),
    showNav () {
      return this.$route.name !== 'auth.index' && this.$route.name !== 'auth.recuperar-senha' && this.$route.name !== 'auth.redefinir-senha'
    }
  },
  methods: {
    ...mapActions(['removeToken']),
    logout () {
      localforage.removeItem('token').then(() => {
        localforage.removeItem('imagem')
        localforage.removeItem('permissoes')
        this.removeToken()
        this.$router.push({ name: 'auth.index' })
      })
    }
  }
}
</script>

<template>
  <div>

    <nav class="nav-extended" v-show="showNav">
      <div class="nav-wrapper col s12">
        <router-link :to="{ name: 'dashboard' }" class="brand-logo center"><img src="./assets/images/logo.png"></router-link>
        <a href="#" ></a>
        <ul class="left">
          <li><a href="#" data-activates="sidebar" id="toggle-sidebar" class="green-text text-darken-3"><i class="material-icons">menu</i></a></li>
        </ul>
        <ul id="nav-mobile" class="right hide-on-med-and-down">
          <li>
            <div class="avatar">
              <img :src="imagem" class="circle dropdown-button responsive-img" data-activates="drop-avatar" v-if="imagem">
              <img src="./assets/images/avatar.png"class="circle dropdown-button responsive-img" data-activates="drop-avatar" v-if="!imagem">
            </div>
            <ul id="drop-avatar" class="dropdown-content z-depth-3">
              <li><router-link :to="{ name: 'usuarios.perfil' }" class="green-text text-darken-3">Meu Perfil</router-link></li>
              <li><a href="#" class="green-text text-darken-3" @click.prevent="logout">Sair</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>

    <ul id="sidebar" class="side-nav" v-show="showNav">
      <li class="hide-on-med-and-down">
        <div class="user-view">
          <div class="background">
            <img src="./assets/images/office.jpg">
          </div>
          <img :src="imagem" class="circle" v-if="imagem">
          <img src="./assets/images/avatar.png" class="circle" v-if="!imagem">
          <span class="white-text name">{{ nome }} {{ sobrenome }}</span>
          <span class="white-text email">{{ email }}</span>
        </div>
      </li>
      <li class="item-unico" v-show="permissoes.indexOf('ata.visualizar') > -1"><router-link :to="{ name: 'atas.index' }" class="to"><i class="material-icons">people</i> ATA's</router-link></li>
      <li class="item-unico"><router-link :to="{ name: 'dashboard' }" class="to"><i class="material-icons">home</i> Home</router-link></li>
      <li class="item-sidebar" v-show="permissoes.indexOf('cliente.visualizar') > -1 || permissoes.indexOf('como-conheceu.visualizar') > -1">
        <a class="waves-effect"><i class="material-icons">people</i> Clientes <i class="material-icons right rotatearrow">keyboard_arrow_down</i></a>
        <div class="collapsible-body">
          <ul>
            <li v-show="permissoes.indexOf('cliente.visualizar') > -1"><router-link :to="{ name: 'clientes.index' }" class="to">Clientes</router-link></li>
            <li v-show="permissoes.indexOf('como-conheceu.visualizar') > -1"><router-link :to="{ name: 'como-conheceu.index' }" class="to">Como Conheceu</router-link></li>
            <li v-show="permissoes.indexOf('cargo.visualizar') > -1"><router-link :to="{ name: 'cargos.index' }" class="to">Cargos</router-link></li>
          </ul>
        </div>
      </li>
      <li class="item-unico" v-show="permissoes.indexOf('fornecedor.visualizar') > -1"><router-link :to="{ name: 'fornecedores.index' }" class="to"><i class="material-icons">people</i> Fornecedores</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('arte.visualizar') > -1"><router-link :to="{ name: 'artes.index' }" class="to"><i class="material-icons">insert_photo</i> Artes</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('tipo-estabelecimento.visualizar') > -1"><router-link :to="{ name: 'tipos-estabelecimento.index' }" class="to"><i class="material-icons">build</i> Tipos de Estabelecimento</router-link></li>
      <li class="item-sidebar" v-show="permissoes.indexOf('financeiro-conta.visualizar') > -1 || permissoes.indexOf('financeiro-categoria.visualizar') > -1 || permissoes.indexOf('financeiro-forma.visualizar') > -1 || permissoes.indexOf('financeiro-pagar.visualizar') > -1 || permissoes.indexOf('financeiro-receber.visualizar') > -1 || permissoes.indexOf('financeiro-extrato.visualizar') > -1">
        <a class="waves-effect"><i class="material-icons">attach_money</i> Financeiro <i class="material-icons right rotatearrow">keyboard_arrow_down</i></a>
        <div class="collapsible-body">
          <ul>
            <li v-show="permissoes.indexOf('financeiro-extrato.visualizar') > -1"><router-link :to="{ name: 'financeiro-extrato.index' }" class="to">Extrato</router-link></li>
            <li v-show="permissoes.indexOf('financeiro-pagar.visualizar') > -1"><router-link :to="{ name: 'financeiro-pagar.index' }" class="to">Contas a Pagar</router-link></li>
            <li v-show="permissoes.indexOf('financeiro-receber.visualizar') > -1"><router-link :to="{ name: 'financeiro-receber.index' }" class="to">Contas a Receber</router-link></li>
            <li v-show="permissoes.indexOf('financeiro-categoria.visualizar') > -1"><router-link :to="{ name: 'financeiro-categorias.index' }" class="to">Cadastros :: Categorias</router-link></li>
            <li v-show="permissoes.indexOf('financeiro-conta.visualizar') > -1"><router-link :to="{ name: 'financeiro-contas.index' }" class="to">Cadastros :: Contas Bancárias</router-link></li>
            <li v-show="permissoes.indexOf('financeiro-conta.visualizar') > -1"><router-link :to="{ name: 'financeiro-formas.index' }" class="to">Cadastros :: Formas de Pagamento</router-link></li>
          </ul>
        </div>
      </li>
      <li class="item-sidebar" v-show="permissoes.indexOf('contato.visualizar') > -1 || permissoes.indexOf('contato.visualizar') > -1 || permissoes.indexOf('contato.visualizar') > -1 || permissoes.indexOf('os.visualizar') > -1 || permissoes.indexOf('venda.visualizar') > -1 || permissoes.indexOf('compra.visualizar') > -1 || permissoes.indexOf('revisao-tipo.visualizar') > -1 || permissoes.indexOf('canal.visualizar') > -1">
        <a class="waves-effect"><i class="material-icons">build</i> Operação <i class="material-icons right rotatearrow">keyboard_arrow_down</i></a>
        <div class="collapsible-body">
          <ul>
            <li v-show="permissoes.indexOf('contato.visualizar') > -1"><router-link :to="{ name: 'contatos.index' }" class="to">Contatos</router-link></li>
            <li v-show="permissoes.indexOf('orcamento.visualizar') > -1"><router-link :to="{ name: 'orcamentos.index' }" class="to">Orçamentos</router-link></li>
            <li v-show="permissoes.indexOf('os.visualizar') > -1"><router-link :to="{ name: 'os.index' }" class="to">OS's</router-link></li>
            <li v-show="permissoes.indexOf('revisao-tipo.visualizar') > -1"><router-link :to="{ name: 'revisao-tipos.index' }" class="to">Tipos de revisão :: OS's</router-link></li>
            <li v-show="permissoes.indexOf('compra.visualizar') > -1"><router-link :to="{ name: 'compras.index' }" class="to">Compras</router-link></li>
            <li v-show="permissoes.indexOf('venda.visualizar') > -1"><router-link :to="{ name: 'vendas.index' }" class="to">Vendas</router-link></li>
            <li v-show="permissoes.indexOf('canal.visualizar') > -1"><router-link :to="{ name: 'canais.index' }" class="to">Canais de Vendas</router-link></li>
            <li v-show="permissoes.indexOf('orcamento-pagamento.visualizar') > -1"><router-link :to="{ name: 'orcamentos-pagamentos.index' }" class="to">Cadastros :: Pagamento</router-link></li>
            <li v-show="permissoes.indexOf('motivo.visualizar') > -1"><router-link :to="{ name: 'motivos.index' }" class="to">Motivos de Recusa</router-link></li>
          </ul>
        </div>
      </li>
      <li class="item-unico" v-show="permissoes.indexOf('equipamento.visualizar') > -1"><router-link :to="{ name: 'equipamentos.index' }" class="to"><i class="material-icons">build</i> Equipamentos</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('produto.visualizar') > -1"><router-link :to="{ name: 'produtos.index' }" class="to"><i class="material-icons">shopping_cart</i> Produtos</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('estoque.visualizar') > -1"><router-link :to="{ name: 'estoque.index' }" class="to"><i class="material-icons">move_to_inbox</i> Estoque</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('grupo.visualizar') > -1"><router-link :to="{ name: 'grupos.index' }" class="to"><i class="material-icons">people</i> Grupos de Serviço</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('servico.visualizar') > -1"><router-link :to="{ name: 'servicos.index' }" class="to"><i class="material-icons">people</i> Serviços</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('objetivo.visualizar') > -1"><router-link :to="{ name: 'objetivos.index' }" class="to"><i class="material-icons">people</i> Objetivos</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('tarefa.visualizar') > -1"><router-link :to="{ name: 'tarefas.index' }" class="to"><i class="material-icons">check_circle_outline</i> Tarefas</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('marca.visualizar') > -1"><router-link :to="{ name: 'marcas.index' }" class="to"><i class="material-icons"></i> Marcas</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('familia.visualizar') > -1"><router-link :to="{ name: 'familias.index' }" class="to"><i class="material-icons"></i> Famílias</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('viatura.visualizar') > -1"><router-link :to="{ name: 'viaturas.index' }" class="to"><i class="material-icons">directions_car</i> Viaturas</router-link></li>
      <li class="item-unico" v-show="permissoes.indexOf('reclamacao.visualizar') > -1"><router-link :to="{ name: 'reclamacoes.index' }" class="to"><i class="material-icons">description</i> Área de Reclamação</router-link></li>
      <li class="item-sidebar" v-show="permissoes.indexOf('usuario.visualizar') > -1">
        <a class="waves-effect"><i class="material-icons">person_pin</i> Usuários <i class="material-icons right rotatearrow">keyboard_arrow_down</i></a>
        <div class="collapsible-body">
          <ul>
            <li><router-link :to="{ name: 'usuarios.index' }" class="to">Usuários</router-link></li>
            <li><router-link :to="{ name: 'perfis.index' }" class="to">Perfis</router-link></li>
            <li><router-link :to="{ name: 'usuarios-logs.index' }" class="to">Logs</router-link></li>
          </ul>
        </div>
      </li>
      <li class="divider"></li>
      <li class="item-sidebar"><router-link :to="{ name: 'usuarios.perfil' }"><i class="material-icons">person</i> Meu Perfil</router-link></li>
      <li class="item-sidebar"><a href="#" class="waves-effect" @click.prevent="logout"><i class="material-icons">power_settings_new</i> Sair</a></li>
      <li class="item-sidebar">
        <a href="#"><small>versão 1.3</small></a>
      </li>
    </ul>

  </div>
</template>



// WEBPACK FOOTER //
// src/the-navigation.vue